import React from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Paper,
} from "@mui/material";

const Wrapper = styled(Paper)(({ theme }) => ({
  height: "100vh",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
}));

const Logo = styled("img")(({ theme }) => ({
  marginBottom: 20,
  height: 50,
}));

const ApiCard = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 430,
  border: `1px solid ${theme.palette.divider}`,

}));

export default function ApiDocsPage() {
  return (
    <Wrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Logo src="WCA-HeaderLogo.png" alt="WCA logo" />
        <Typography variant="h5" sx={{ ml: 1.25 }}>
          Developer Portal
        </Typography>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 900, mb: 2 }}
      >
        Welcome to the WCA Developer Portal. WCA APIs provide programmatic
        access to inventory data and automated order submission, allowing
        customers and partners to integrate WCA services directly into their
        own applications, reporting tools, and business workflows.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Getting Started
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 900, mb: 1 }}
      >
        Each API documentation page contains authentication requirements,
        endpoint references, request and response examples, error codes, and
        sample integrations. 
        
        Please contact your WCA representative to request access and obtain
        your API credentials.
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 900, mb: 2 }}
      >
        Select an API below to begin exploring the available endpoints.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
        Available APIs
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <ApiCard>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Inventory API v1.0
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 1 }}
            >
              Retrieve inventory levels and stock availability in real time
              through the Inventory API.
            </Typography>

            <Button 
            variant="outlined" 
            color="primary"
            href="https://portal.wca.com/api/docs/#tag/Inventory"
            // href="https://portal-sandbox.wcaoem.com/api/docs/#tag/Inventory"
            >
              Inventory API Docs
            </Button>
          </CardContent>
        </ApiCard>

        <ApiCard>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Orders API v1.0
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 1 }}
            >
              Automate order submission with the
              Orders API.
            </Typography>

            <Button 
              variant="outlined" 
              color="primary"
              href="https://portal.wca.com/api/docs/#tag/Orders"
              // href="http://portal-sandbox.wcaoem.com/api/docs/#tag/Orders"
              >
              Orders API Docs
            </Button>
          </CardContent>
        </ApiCard>
      </Box>
    </Wrapper>
  );
}